export const PIX = 'pix';
export const CREDITCARD = 'credit_card';
export const FREE = 'free';
export const EVENTID = process.env.REACT_APP_EVENT_ID;
export const ACCOUNTID = process.env.REACT_APP_ACCOUNT_ID;
export const TESTMODE = process.env.REACT_APP_TEST_MODE === '1' ? true : false;
export const DEV = process.env.REACT_APP_ENV === 'dev';
export const PIXEXPIRETIME = 300;
export const MICE_EVENT_ID = parseInt(
  process.env.REACT_APP_MICE_EVENT_ID || '0',
);
